// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".is-right > button {\n  background: #25A376 !important;\n  color: #fff !important;\n  padding: 0;\n}", "",{"version":3,"sources":["webpack://./src/app/styles/global.scss"],"names":[],"mappings":"AACA;EACE,8BAAA;EACA,sBAAA;EACA,UAAA;AAAF","sourcesContent":["// fancboxni customize qilish uchun\n.is-right > button {\n  background: #25A376 !important;\n  color: #fff !important;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
